import { styled } from '@mui/material/styles';
import React, { PropsWithChildren, useRef, useState } from 'react';
import { ToolTip } from '../ToolTip';

const Wrapper = styled('div')`
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TruncatedText = ({
  className,
  alternateTooltip,
  children,
  dataCy,
  ...otherProps
}: PropsWithChildren<{
  className?: string;
  /*
   * A detailed alternate tooltip when the text is truncated.
   */
  alternateTooltip?: React.ReactNode;
  /**
   * Optional data-cy attribute for testing
   */
  dataCy?: string;
}>) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleShowTooltip = (
    event: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>
  ) => {
    const wrapperElement = event.currentTarget;
    const isTruncated = wrapperElement.scrollWidth > wrapperElement.clientWidth;
    setShowTooltip(isTruncated);
  };

  const handleHideTooltip = () => {
    setShowTooltip(false);
  };

  return (
    <ToolTip
      disableInteractive
      open={showTooltip}
      placement="bottom"
      arrow
      title={alternateTooltip ?? wrapperRef.current?.innerText}
    >
      <Wrapper
        {...otherProps}
        ref={wrapperRef}
        className={className}
        onMouseEnter={handleShowTooltip}
        onMouseLeave={handleHideTooltip}
        onTouchStart={handleShowTooltip}
        onTouchEnd={handleHideTooltip}
        data-cy={dataCy ? dataCy : 'truncatedText'}
      >
        {children}
      </Wrapper>
    </ToolTip>
  );
};
